/* eslint-disable import/prefer-default-export */
export function secondsToMinutesAndSeconds( seconds ) {
    const m = Math.floor( seconds / 60 )
    const s = seconds % 60
    return `${ m }:${ s < 10 ? '0' : '' }${ s }`
}
